import { SignatureMatrixAction, SignatureMatrixActionTypes } from '@completion/actions';
import { SignatureType } from '@completion/enums';
import { SignatureSetupCopyResult, SignatureSetupCopySource } from '@completion/models';

export interface SignatureMatrixState {
  currentType: SignatureType;
  customType: string;
  signatureSetupCopySources: SignatureSetupCopySource[];
  signatureSetupCopyResult: SignatureSetupCopyResult | null;
}

export const initialState: SignatureMatrixState = {
  currentType: null,
  customType: null,
  signatureSetupCopySources: [],
  signatureSetupCopyResult: null,
};

export function signatureMatrixReducer(state: SignatureMatrixState = initialState, action: SignatureMatrixAction): SignatureMatrixState {
  switch (action.type) {
    case SignatureMatrixActionTypes.SetMatrixType:
      return {
        ...state,
        currentType: action.matrixType,
      };
    case SignatureMatrixActionTypes.ClearCurrentType:
      return {
        ...state,
        currentType: null,
        customType: null,
      };
    case SignatureMatrixActionTypes.SetCustomMatrixType:
      return {
        ...state,
        customType: action.matrixType,
      };
    case SignatureMatrixActionTypes.SignatureSetupCopySourcesLoad:
      return {
        ...state,
        signatureSetupCopySources: [],
      };
    case SignatureMatrixActionTypes.SignatureSetupCopySourcesLoadSuccess:
      return {
        ...state,
        signatureSetupCopySources: action.sources,
      };
    case SignatureMatrixActionTypes.SignatureSetupCopy:
      return {
        ...state,
        signatureSetupCopyResult: null,
      };
    case SignatureMatrixActionTypes.SignatureSetupCopySuccess:
      return {
        ...state,
        signatureSetupCopyResult: action.result,
      };
    default:
      return state;
  }
}
